import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'jyapi/login_submit',
    method: 'POST',
    data
  })
}

export function registerApi(data) {
  return request({
    url: 'jyapi/register_submit',
    method: 'POST',
    data
  })
}
export function userInfoApi(data) {
  return request({
    url: 'jyapi/user_info',
    method: 'POST',
    data
  })
}
export function userCheckApi(data) {
  return request({
    url: 'jyapi/user_check',
    method: 'POST',
    data
  })
}
// 发布
export function publish_informationApi(data) {
  return request({
    url: 'jyapi/publish_information',
    method: 'POST',
    data
  })
}
// 发布查询
export function information_listApi(data) {
  return request({
    url: 'jyapi/information_list',
    method: 'POST',
    data
  })
}
// 接单
export function take_informationApi(data) {
  return request({
    url: 'jyapi/take_information',
    method: 'POST',
    data
  })
}
export function take_information_listApi(data) {
  return request({
    url: 'jyapi/take_information_list',
    method: 'POST',
    data
  })
}
// 退单
export function abandonOrderApi(params) {
  return request({
    url: 'jyapi/waive_information',
    params
  })
}
// 图片上传
export function resources_insertApi(data) {
  return request({
    url: 'jyapi/resources_insert',
    method: 'POST',
    data
  })
}
// 信息修改
export function update_user_infoApi(data) {
  return request({
    url: 'jyapi/update_user_info',
    method: 'POST',
    data
  })
}
// 申请展厅
export function applyDisplayApi(data) {
  return request({
    url: 'jyapi/add_exhibition_hall',
    method: 'POST',
    data
  })
}
// 完结订单
export function finishOrderApi(params) {
  return request({
    url: 'jyapi/success_information',
    params
  })
}